export class BasketFormAnswer {
	QuestionId: number;
	IntValue: number | null;
	BoolAnswer: boolean | null;
	TextAnswer: string;
	MultiAnswer: number[] | null;
}
